module.exports = __webpack_public_path__ + "static/media/germansuperheavy.aa54b4da.jpg";